import EventActionProto from '../event-action-proto';

class EventUpdateNew extends EventActionProto{

    constructor(uid, data) {
        super(uid, data);
    }

    process() {
        gd.session.counters.increaseNotificationsCount();
    }

}

module.exports = EventUpdateNew;
